import React from 'react';
import { Box } from '@material-ui/core';

interface ToggleButtonProps {
  filterByFinished: boolean;
  setFilterByFinished: React.Dispatch<React.SetStateAction<boolean>>;
}

const ToggleButton = ({
  filterByFinished,
  setFilterByFinished,
}: ToggleButtonProps) => {
  return (
    <Box
      pb={2}
      pt={0.5}
      borderBottom="1px solid #ebebeb"
      borderTop="1px solid #ebebeb"
    >
      <div className="title">Filtrar data por</div>
      <Box mx={2} mt={1}>
        <Box
          display="flex"
          bgcolor="#E9EAED"
          borderRadius={999}
          p="4px"
          position="relative"
          width="auto"
          height={40}
          mx={3}
        >
          <Box
            position="absolute"
            top="4px"
            left={!filterByFinished ? '4px' : 'calc(50% + 4px)'}
            width="calc(50% - 8px)"
            height="32px"
            bgcolor="#fff"
            borderRadius="999px"
            style={{ transition: 'left 0.3s ease' }}
            zIndex={0}
          />

          <Box
            component="div"
            width="50%"
            textAlign="center"
            lineHeight="32px"
            fontWeight={500}
            color="#000"
            zIndex={1}
            style={{ cursor: 'pointer' }}
            onClick={() => setFilterByFinished(false)}
          >
            Criação
          </Box>
          <Box
            component="div"
            width="50%"
            textAlign="center"
            lineHeight="32px"
            fontWeight={500}
            color="#000"
            zIndex={1}
            style={{ cursor: 'pointer' }}
            onClick={() => setFilterByFinished(true)}
          >
            Finalização
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ToggleButton;
